import { z } from 'zod';

import { jsonCodec } from 'src/app/shared/utils/zod';

// TODO: actually validate the draft structure, probably centralize this logic in relation to the state machine context
export const schema = jsonCodec(
	z.object({
		id: z.string(),
		type: z.string().nullable().optional(),
		input: z.looseObject({}).nullable().optional(),
		petitionDraft: z.looseObject({}).nullable().optional(),
		recommendedDraft: z.looseObject({}).nullable().optional(),
		metadata: z.looseObject({}).nullable().optional(),
	}),
);

export type Schema = z.infer<typeof schema>;
